<script lang="ts" setup>
const { createEvent } = useAnalytics()
const { t } = useI18n()
const authStore = useAuthStore()
const localePath = useLocalePath()
const router = useRouter()

onMounted(async () => {
  await authStore.logout()

  createEvent({ name: '[Auth] Logout' })

  router.push(localePath('index'))
})
</script>

<template>
  <UContainer class="mx-auto flex h-full flex-col items-center justify-center gap-4 py-20 md:gap-6">
    <BasePower />

    <BaseHeading
      class="w-full"
      :description="t('description')"
      tag="h1"
      :title="t('title')"
    />

    <BaseSpinner class="size-10" />
  </UContainer>
</template>

<i18n lang="json">
{
  "en": {
    "description": "Please, wait a few seconds while we log you out.",
    "title": "Logging out…"
  },
  "es": {
    "description": "Por favor, espere unos segundos mientras nos desconectamos.",
    "title": "Desconectando…"
  },
  "fr": {
    "description": "Veuillez patienter quelques secondes pendant que nous vous déconnectons.",
    "title": "Déconnexion en cours…"
  }
}
</i18n>
